module.exports = __webpack_public_path__ + "img/house.be5030ca.webp";